<template>
  <video v-if="!isMobile" ref="video" loop muted playsinline preload="metadata">
    <source :src="this.av1" type="video/mp4; codecs=av01.0.05M.08" />
    <source :src="this.mp4" type="video/mp4" />
  </video>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { isInViewport } from '~scripts/core/helpers';

export default {
  name: 'ForumResultsVideo',
  props: {
    av1: String,
    mp4: String,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${this.breakpoints.smMax})`);
    },
    sectionEl() {
      return document.getElementById('forum-results');
    },
  },
  mounted() {
    this.mediaSm.addEventListener('change', this.handleMediaChange);
    this.handleMediaChange(this.mediaSm);

    document.addEventListener('scroll', this.handleVideoToggle);
    this.handleVideoToggle();
  },
  beforeDestroy() {
    this.mediaSm.removeEventListener('change', this.handleMediaChange);

    document.removeEventListener('scroll', this.handleVideoToggle);
  },
  methods: {
    handleMediaChange(event) {
      const isMobile = event.matches;

      if (isMobile) {
        document.removeEventListener('scroll', this.handleVideoToggle);
      } else {
        document.addEventListener('scroll', this.handleVideoToggle);
      }

      this.isMobile = isMobile;
    },
    playVideo() {
      this.$refs.video.play();
    },
    stopVideo() {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
    handleVideoPlay() {
      if (!this.isMobile) {
        this.playVideo();
      }
    },
    handleVideoStop() {
      if (!this.isMobile) {
        this.stopVideo();
      }
    },
    handleVideoToggle() {
      if (isInViewport(this.sectionEl)) {
        this.handleVideoPlay();
      } else {
        this.handleVideoStop();
      }
    },
  },
};
</script>
